import React from "react";


import { useFormikContext } from "formik";
import { Grid } from "@mui/material";
import { Genders, Pronouns } from "types/gql-types";

import { MaterialFormikSelect as SelectWithLabel } from "components/haven-design/form/select";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";

const GenderDropdown:React.FC = () => {
  const { values: { gender, pronouns } } =
    useFormikContext<{gender: Genders, pronouns: Pronouns}>();

  const showPronouns = gender === Genders.OTHER;
  const showCustomPronouns = showPronouns && pronouns === Pronouns.OTHER;

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <SelectWithLabel title="Gender" name="gender" options={[
          { label: "Male", value: Genders.MALE },
          { label: "Female", value: Genders.FEMALE },
          { label: "Trans", value: Genders.TRANS },
          { label: "Other", value: Genders.OTHER },
        ]} />
        <hr />
      </Grid>

      {showPronouns && (
        <Grid size={{ xs: 12 }}>
          <SelectWithLabel title="Pronouns" name="pronouns" options={[
            { label: "He/Him", value: Pronouns.HE_HIM },
            { label: "She/Her", value: Pronouns.SHE_HER },
            { label: "They/Them", value: Pronouns.THEY_THEM },
            { label: "Other - Write In", value: Pronouns.OTHER },
          ]} />
          <hr />
        </Grid>
      )}

      {showCustomPronouns && (
        <Grid size={{ xs: 12 }}>
          <InputWithErrorLabel label="Custom Pronouns" name="customPronouns" type="text" />
          <hr />
        </Grid>
      )}
    </>
  );
};

export default GenderDropdown;
